/* eslint-disable */
/**
 * @author roryhe
 * @desc 页面级水印js
 */
(function () {
  // canvas 实现 watermark
  function __canvasWM({
                        // 使用 ES6 的函数默认值方式设置参数的默认取值
                        // 具体参见 https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Functions/Default_parameters
                        container = document.body,
                        width = '300px',
                        height = '300px',
                        textAlign = 'center',
                        textBaseline = 'middle',
                        font = '14px microsoft yahei',
                        fillStyle = 'rgba(184, 184, 184, .2)',
                        content = '请勿外传',
                        rotate = '-45',
                        zIndex = 99999
                      } = {}) {
    // const args = arguments[0];
    const canvas = document.createElement('canvas');

    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);
    const ctx = canvas.getContext('2d');

    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.rotate(Math.PI / 180 * rotate);
    ctx.fillText(content.name, 0, parseFloat(height) / 2);
    ctx.fillText(content.id, 0, parseFloat(height) / 2 + 20);

    const base64Url = canvas.toDataURL();
    const watermarkDiv = document.createElement('div');
    watermarkDiv.className = 'jp-financing-watermark';
    watermarkDiv.setAttribute('style', `
      position:fixed;
      top:0;
      left:0;
      width:100%;
      height:100%;
      z-index:${zIndex};
      pointer-events:none;
      background-repeat:repeat;
      background-image:url('${base64Url}')`);

    container.style.position = 'relative';
    // 先删除已有水印
    const oldVM = container.querySelector('.jp-financing-watermark');
    if (oldVM) {
      container.removeChild(oldVM);
    }
    // 再重新添加水印。
    container.insertBefore(watermarkDiv, container.firstChild);
  }

  window.__canvasWM = __canvasWM;
})();


// eslint-disable-next-line
module.exports = __canvasWM;
// // 调用
// __canvasWM({
//   content: 'QQMusicFE'
// })
